import React, { useState, useEffect } from "react";
import { Table, Spin, message, Button, Space } from "antd";
import { fetchSubjects } from "../../ApiServices/getSubjectService";
import { getSubjectTableColumns } from "../../Config/subjectTableColumns";
import CreateSubjectModal from "../../Components/CreateSubjectModal/CreateSubjectModal";

const Subjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadSubjects = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const subjectsData = await fetchSubjects();
      console.log("Fetched subjects data:", subjectsData);
      setSubjects(subjectsData);
      message.success("Subjects data loaded successfully");
    } catch (error) {
      console.error("Error fetching subjects:", error);
      setError(error.message);
      
      if (error.response) {
        message.error(`Server error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
      } else if (error.request) {
        message.error("Network error - Could not connect to server");
      } else {
        message.error(error.message || "Failed to fetch subjects");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSubjects();
  }, []);

  const columns = getSubjectTableColumns();

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Space>
          <Button 
            type="primary" 
            onClick={loadSubjects}
            loading={loading}
          >
            Refresh Data
          </Button>
          <CreateSubjectModal onSubjectCreated={loadSubjects} />
        </Space>
      </div>
      
      <Spin spinning={loading} tip="Loading subjects...">
        {error && (
          <div style={{ color: 'red', marginBottom: 16 }}>
            Error: {error}
          </div>
        )}
        <Table 
          columns={columns} 
          dataSource={subjects}
          rowKey={(record) => record.id || Math.random().toString(36).substr(2, 9)}
          locale={{ emptyText: error ? "Error loading data" : "No subjects found" }}
        />
      </Spin>
    </div>
  );
};

export default Subjects;